export const PageHero = ({ eyebrow, title, text, image = "/images/fleet.jpg" }) => (
  <section className="relative grain overflow-hidden" data-testid="page-hero">
    <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/50" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      <p className="rise text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">{eyebrow}</p>
      <h1 className="rise rise-1 mt-4 font-display font-black uppercase tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="page-title">{title}</h1>
      {text && <p className="rise rise-2 mt-5 max-w-2xl text-base sm:text-lg text-slate-300">{text}</p>}
    </div>
  </section>
);
